var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "tender-item" },
    [
      _c("div", { staticClass: "tender-item__header" }, [
        _c("b", [_vm._v("Закупка:")]),
        _vm._v(" "),
        _vm.tender.purchase_number
          ? _c(
              "a",
              {
                attrs: {
                  href: _vm.getLink(
                    _vm.tender.tender_law,
                    _vm.tender.purchase_number
                  ),
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.tender.purchase_number))]
            )
          : _c("b", [_vm._v("Б/Н")]),
        _vm._v(" "),
        _c("b", [_vm._v("от " + _vm._s(_vm.dateParser(_vm.tender.date)))]),
        _vm._v(" "),
        _c("span", { staticClass: "grey" }, [
          _vm._v("(" + _vm._s(_vm.tender.tender_law) + "-ФЗ)"),
        ]),
      ]),
      _vm._v(" "),
      _vm.tender.title
        ? _c("p", { staticClass: "tender-item__description" }, [
            _c("b", [_vm._v(_vm._s(_vm.tender.title))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.tender.customers.length
        ? _c(
            "div",
            { staticClass: "tender-item__customers" },
            [
              _vm.tender.customers.length > 1
                ? [
                    _c("b", [_vm._v("Заказчики:")]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "small-list" },
                      _vm._l(_vm.tender.customers, function (c, i) {
                        return _c("li", { key: i }, [
                          c.ogrn || c.inn
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "card-link",
                                    { attrs: { ogrn: c.ogrn || c.inn } },
                                    [_vm._v(_vm._s(c.name))]
                                  ),
                                  _vm._v(" "),
                                  _c("tooltip", {
                                    staticClass: "stay-on-row",
                                    attrs: { ogrn: c.ogrn || c.inn },
                                  }),
                                ],
                                1
                              )
                            : _c("span", [_vm._v(_vm._s(c.name))]),
                        ])
                      }),
                      0
                    ),
                  ]
                : _c(
                    "span",
                    [
                      _c("b", [_vm._v("Заказчик:")]),
                      _vm._v(" "),
                      _vm.tender.customers[0].ogrn ||
                      _vm.tender.customers[0].inn
                        ? [
                            _c(
                              "card-link",
                              {
                                attrs: {
                                  ogrn:
                                    _vm.tender.customers[0].ogrn ||
                                    _vm.tender.customers[0].inn,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.tender.customers[0].name) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("tooltip", {
                              staticClass: "stay-on-row",
                              attrs: {
                                ogrn:
                                  _vm.tender.customers[0].ogrn ||
                                  _vm.tender.customers[0].inn,
                              },
                            }),
                          ]
                        : _c("span", [
                            _vm._v(_vm._s(_vm.tender.customers[0].name)),
                          ]),
                    ],
                    2
                  ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tender.purchase_sum
        ? _c("div", { staticClass: "tender-item__max_price" }, [
            _c("b", [_vm._v("Максимальная цена закупки:")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.moneyFormat(_vm.tender.purchase_sum, 2)) + " "),
              _c("i", { staticClass: "uk-icon-rub" }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.tender.contracts_sum
        ? _c("div", { staticClass: "tender-item__price" }, [
            _c("b", [_vm._v("Сумма закупки:")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.moneyFormat(_vm.tender.contracts_sum, 2)) + " "
              ),
              _c("i", { staticClass: "uk-icon-rub" }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.tender.lots && _vm.tender.lots.length
        ? _c("tenders-lots-list", {
            attrs: {
              lotsList: _vm.tender.lots,
              law: Number(_vm.tender.tender_law),
              links: _vm.links,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }